/* Park Market — small global JS: drawers, countdown, viewport reveal */
(() => {
  'use strict';

  const root = document.documentElement;
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------ "Join the list" with no sign-up on the page ------------------------ */
  /* The header's "Join the list" (and any other #waitlist link) jumps to the
     sign-up section, which only some templates carry, so on the homepage and
     the product pages it went nowhere. Where the page has no #waitlist: open
     the launch list pop-up while it is running (email and phone), otherwise
     go to the sign-up on the Bag Charms page, which takes a phone too. */
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a[href="#waitlist"]');
    if (!a) return;
    /* The email list card, while it's switched on, takes every "Join the
       list" link (pm-list-card). A menu drawer closes first. */
    if (typeof window.pmListOpen === 'function') {
      e.preventDefault();
      document.querySelectorAll('[data-pm-drawer][data-open="true"] [data-pm-close]').forEach((c) => c.click());
      window.pmListOpen();
      return;
    }
    if (document.getElementById('waitlist')) return;
    e.preventDefault();
    if (typeof window.pmLaunchOpen === 'function' && window.pmLaunchOpen() !== false) return;
    window.location.href = '/collections/bag-charms#waitlist';
  });

  /* ------------------------ waitlist: no-reload submit (CAPTCHA-safe) ------------------------ */
  /* The waitlist uses Shopify's {% form 'customer' %}, and this store has spam
     protection (invisible CAPTCHA) enabled on it. Shopify's own script attaches
     a CAPTCHA token at submit time and submits the form natively — a background
     fetch() cannot reproduce that token, so Shopify rejects it with 400
     "Missing CAPTCHA token" (the old code then showed a spurious error while
     Shopify's native submit reloaded the page and scrolled to the form anchor).

     So we let the form submit NATIVELY — keeping Shopify's CAPTCHA flow intact —
     but retarget it into a hidden iframe so the top window never reloads or
     scrolls. We then read the iframe's result and swap the confirmation in
     place. Delegated on `document` so re-rendered/late forms are covered. */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-pm-waitlist] form');
    if (!form) return;

    const email = form.querySelector('input[type="email"]');
    if (email && !email.checkValidity()) { e.preventDefault(); email.reportValidity(); return; }

    const wrap = form.closest('[data-pm-waitlist]');
    const btn = form.querySelector('button[type="submit"]');
    const label = btn ? btn.textContent : '';
    const errEl = form.querySelector('[data-pm-wl-error]');
    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }

    /* Optional phone: never posted as contact[phone] (Shopify would reject the
       whole signup over a number it dislikes, and drops SMS consent anyway).
       It rides along as tags, sms-<digits> plus the form's SMS tag, which the
       SMS sync turns into consent on the customer. */
    const phoneEl = form.querySelector('[data-pm-wl-phone]');
    const tagsEl = form.querySelector('[data-pm-wl-tags]');
    if (phoneEl && tagsEl) {
      const raw = phoneEl.value.trim();
      let dg = raw.replace(/\D/g, '');
      if (raw && raw.charAt(0) !== '+' && dg.length === 10) dg = '1' + dg;
      if (raw && (dg.length < 8 || dg.length > 15)) {
        e.preventDefault();
        if (errEl) { errEl.textContent = 'That phone number looks off. Fix it, or leave it blank for emails only.'; errEl.hidden = false; }
        phoneEl.focus();
        return;
      }
      tagsEl.value = tagsEl.dataset.base + (raw ? ', ' + tagsEl.dataset.sms + ', sms-' + dg : '');
    }
    if (btn) { btn.disabled = true; btn.textContent = 'Joining…'; }

    /* Hidden iframe "sink" — created once, reused across submits. */
    let sink = document.getElementById('pm-wl-sink');
    if (!sink) {
      sink = document.createElement('iframe');
      sink.id = 'pm-wl-sink';
      sink.name = 'pm-wl-sink';
      sink.setAttribute('aria-hidden', 'true');
      sink.setAttribute('tabindex', '-1');
      sink.style.cssText = 'position:absolute;width:0;height:0;border:0;left:-9999px;top:-9999px;';
      document.body.appendChild(sink);
    }

    /* Route the native submit into the iframe. Shopify's CAPTCHA flow re-submits
       the form itself (form.submit()), which reads this same target, so the
       tokened post still lands in the iframe — never the top window.
       We deliberately do NOT preventDefault: the native submit must proceed. */
    form.target = 'pm-wl-sink';

    /* Safety net: if the iframe never resolves (network hang), free the button. */
    const timer = setTimeout(() => {
      sink.removeEventListener('load', onLoad);
      showError('');
    }, 15000);

    function onLoad() {
      let href = 'about:blank';
      try { href = sink.contentWindow.location.href; } catch (_) { href = ''; }
      if (href === 'about:blank') return; // ignore the iframe's initial blank load
      sink.removeEventListener('load', onLoad);
      clearTimeout(timer);
      let html = '';
      try { html = sink.contentDocument ? sink.contentDocument.documentElement.outerHTML : ''; } catch (_) {}
      const errored = html.indexOf('data-pm-wl-server-err') !== -1;
      const confirmed =
        !errored &&
        (href.indexOf('customer_posted=true') !== -1 ||
          html.indexOf('data-pm-wl-server-ok') !== -1 ||
          href === ''); // cross-origin/unreadable but the native post completed
      if (confirmed) { showSuccess(); } else { showError(extractError(html)); }
    }
    sink.addEventListener('load', onLoad);

    function showSuccess() {
      clearTimeout(timer);
      /* Reset the button too: the row is hidden on success, but resetting
         guards against the label staying stuck on "Joining…" if the row
         ever fails to hide. */
      if (btn) { btn.disabled = false; btn.textContent = label; }
      const ok = wrap ? wrap.querySelector('[data-pm-wl-success]') : null;
      const row = form.querySelector('.pm-waitlist__row');
      const lbl = form.querySelector('label');
      const fine = form.querySelector('.pm-waitlist__fineprint');
      const legal = form.querySelector('.pm-waitlist__legal');
      if (row) row.hidden = true;
      if (lbl) lbl.hidden = true;
      if (fine) fine.hidden = true;
      if (legal) legal.hidden = true;
      if (ok) {
        ok.hidden = false;
        ok.setAttribute('tabindex', '-1');
        try { ok.focus({ preventScroll: true }); } catch (_) {}
      }
    }

    function showError(msg) {
      clearTimeout(timer);
      if (btn) { btn.disabled = false; btn.textContent = label; }
      if (errEl) {
        errEl.textContent = msg || "Hm, that didn't clip on right. Try again?";
        errEl.hidden = false;
      }
    }

    function extractError(html) {
      try {
        const el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pm-wl-server-err]');
        if (el && el.textContent.trim()) return el.textContent.trim();
      } catch (_) {}
      return '';
    }
  });

  /* ------------------------ drawers (mobile menu, cart) ------------------------ */
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-pm-open]');
    if (opener) {
      e.preventDefault();
      const sel = opener.getAttribute('data-pm-open');
      const target = document.querySelector(sel);
      if (target) {
        openDrawer(target);
        if (opener.hasAttribute('aria-expanded')) opener.setAttribute('aria-expanded', 'true');
      }
    }
    const closer = e.target.closest('[data-pm-close]');
    if (closer) {
      e.preventDefault();
      const sel = closer.getAttribute('data-pm-close');
      const target = sel ? document.querySelector(sel) : closer.closest('[data-pm-drawer]');
      if (target) closeDrawer(target);
    }
    const drawer = e.target.closest('[data-pm-drawer]');
    if (drawer && e.target === drawer) closeDrawer(drawer);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-pm-drawer][data-open="true"]').forEach(closeDrawer);
    }
  });
  function openDrawer(el) {
    el.dataset.open = 'true';
    el.setAttribute('aria-hidden', 'false');
    if (el.tagName === 'DIALOG' && typeof el.show === 'function') el.show();
    else if (el.hasAttribute('open') === false) el.setAttribute('open', '');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer(el) {
    el.dataset.open = 'false';
    el.setAttribute('aria-hidden', 'true');
    el.removeAttribute('open');
    document.documentElement.style.overflow = '';
    if (el.id) {
      document.querySelectorAll(`[data-pm-open="#${el.id}"][aria-expanded]`).forEach((btn) => {
        btn.setAttribute('aria-expanded', 'false');
      });
    }
  }

  /* ------------------------ countdown ------------------------ */
  document.querySelectorAll('[data-pm-countdown]').forEach((el) => {
    const target = new Date(el.getAttribute('data-pm-countdown')).getTime();
    if (Number.isNaN(target)) return;
    const tick = () => {
      const diff = Math.max(0, target - Date.now());
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      paint(el, 'd', d);
      paint(el, 'h', h);
      paint(el, 'm', m);
      paint(el, 's', s);
      if (diff <= 0) {
        clearInterval(timer);
        el.dispatchEvent(new CustomEvent('pm:countdown:done'));
      }
    };
    function paint(root, k, v) {
      const cell = root.querySelector(`[data-pm-cd="${k}"]`);
      if (cell) cell.textContent = String(v).padStart(2, '0');
    }
    const timer = setInterval(tick, 1000);
    tick();
  });

  /* ------------------------ reveal on scroll ------------------------ */
  if ('IntersectionObserver' in window && !reduceMotion) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('pm-in-view');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );
    document.querySelectorAll('[data-pm-reveal]').forEach((el) => io.observe(el));
  } else {
    document.querySelectorAll('[data-pm-reveal]').forEach((el) => el.classList.add('pm-in-view'));
  }

  /* ------------------------ pdp gallery ------------------------ */
  document.querySelectorAll('[data-pm-gallery]').forEach((root) => {
    const main = root.querySelector('[data-pm-gallery-main]');
    const thumbs = root.querySelectorAll('[data-pm-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach((t) => {
      t.addEventListener('click', () => {
        const src = t.getAttribute('data-src') || t.querySelector('img')?.src;
        if (src && main.querySelector('img')) main.querySelector('img').src = src;
        thumbs.forEach((x) => x.setAttribute('aria-selected', 'false'));
        t.setAttribute('aria-selected', 'true');
      });
    });
  });

  /* ------------------------ smooth anchor scroll ------------------------ */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;
    const id = a.getAttribute('href').slice(1);
    if (!id) return;
    const tgt = document.getElementById(id);
    if (!tgt) return;
    e.preventDefault();
    tgt.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    history.replaceState(null, '', `#${id}`);
  });
})();
